import type { HTMLAttributes } from "react";

import { clsx } from "../../utils/clsx";

interface ModalActionsProps extends HTMLAttributes<HTMLDivElement> {}

export const ModalActions = ({ className, ...rest }: ModalActionsProps) => {
  return <div className={clsx("shrink-0 bg-gray-100 [grid-area:actions]", className)} {...rest} />;
};
